export enum DeepLinksEnum {
  AFTER_SALES = 'afterSales',
  REGISTRATION_FORM = 'registrationForm',
  LANDING_PAGE = 'landingPage',
  REDEMPTION = 'redemption',
}
